import { gql } from '@jupiter/ts-monorepo';
import config from "@/config";

export const useUserStore = defineStore('user', () => {
    // const
    const apiUrl = config.api.uri;
    const fsApiUrl = config.api.fsUri;
    const cdnUrl = config.api.cdnUrl;

    // data
    const me = ref(null);

    const login = async (username: string, password: string) => {
        const response = await fetch(`${apiUrl}/api/v1/user/login`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                email: username,
                password: password,
            }),
        });

        if (!response.ok) {
            return null;
        }

        const token = await response.json();
        window.localStorage.setItem(
            'auth-info',
            JSON.stringify(token['jupiter']),
        );
        window.localStorage.setItem(
            'auth-token',
            token['jupiter']['access_token'],
        );
        window.localStorage.setItem(
            'abc-auth-info',
            JSON.stringify(token['abc']),
        );
        window.localStorage.setItem(
            'abc-auth-token',
            token['abc']['accessToken'],
        );
        return response;
    };

    const socialLogin = async (userInfo: any, provider: string) => {
        const response = await fetch(`${apiUrl}/api/v1/user/social-login`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                provider: provider,
                provider_id: userInfo.sub,
                name: userInfo.name,
                email: userInfo.email,
            }),
        });

        if (!response.ok) {
            return null;
        }

        const token = await response.json();
        window.localStorage.setItem(
            'auth-info',
            JSON.stringify(token),
        );
        window.localStorage.setItem(
            'auth-token',
            token['access_token'],
        );
        return response;
    }

    const getMe = async () => {
        const userId = getUserUUID();
        const hasuraClient = await getHasuraClient();
        const response = await hasuraClient.query({
            query: GET_ME,
            fetchPolicy: 'network-only',
            variables: {
                id: userId,
            }
        });
        me.value = null;
        if (response && response.data) {
            const _me = {
                ...response.data.user_users_by_pk,
            };

            const _profile: any = {
                src: null,
            };
            if (_me.profile) {
                _profile.src = `${cdnUrl}/${_me.profile.src}`;
            }
            me.value = {
                ..._me,
                profile: _profile,
            };
        }
        return response;
    };

    const updateMe = async (data: any) => {
        const userId = getUserUUID();
        const hasuraClient = await getHasuraClient();

        const response = await hasuraClient.mutate({
            mutation: UPDATE_USER_BY_PK,
            fetchPolicy: 'network-only',
            variables: {
                id: userId,
                set: data,
            }
        });

        return response;
    };

    const logout = () => {
        clearLocalStorage();
        location.href = `/`;
    };

    const loginWallet = async (id: string, password: string) => {
        const response = await fetch(`${fsApiUrl}/api/auth/login`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                email: id,
                password: password,
            }),
        });


        if (!response.ok) {
            return null;
        }

        const token = await response.json();

        window.localStorage.setItem(
            'abc-auth-info',
            JSON.stringify(token['data']),
        );
        window.localStorage.setItem(
            'abc-auth-token',
            token['data']['accessToken'],
        );
        return response;
    };

    const getAbcAccount = async () => {
        const response = await sendFsApi('api/auth/account', 'GET');
        if (response.status === 200 && response.data.status === 'success') {
            return response.data.data;
        }
        return null;
    }
    
    const getAbcBalance = async () => {
        const response = await sendFsApi('api/auth/balance', 'GET');
        if (response.status === 200 && response.data.status === 'success') {
            return response.data.data;
        }
        return null;
    }

    return {
        // data
        me,

        // methods
        login,
        socialLogin,
        logout,
        getMe,
        updateMe,
        loginWallet,
        getAbcAccount,
        getAbcBalance
    };
});

const GET_ME = gql`
    query getMe($id: uuid!) {
        user_users_by_pk(id: $id) {
            id
            name
            email
            phone
            nickname
            introduction
            wallet_address
            profile {
                src
            }
            artist {
                id
                name
                description
            }
            brand {
                id
                name
                description
            }
            influencer {
                id
                name
                description
                discord_url
                instagram_url
                etc_sns
                feeds_aggregate {
                    aggregate {
                        count
                    }
                }
            }
            followers_aggregate(
                where: {
                    deleted_at: {
                        _is_null: true
                    }
                }
            ) {
                aggregate {
                    count
                }
            }
            followings_aggregate (
                where: {
                    deleted_at: {
                        _is_null: true
                    }
                }
            ) {
                aggregate {
                    count
                }
            }
        }
    }
`;

const UPDATE_USER_BY_PK = gql`
    mutation updateUserByPk(
        $id: uuid!
        $set: user_users_set_input!
    ) {
        update_user_users_by_pk (
            pk_columns: {
                id: $id
            }
            _set: $set
        ) {
            id
            updated_at
            deleted_at
        }
    }
`;